export default __webpack_public_path__ + "static/solution_back-311c41c340598a41eb9a2d86a30c5ddd.webp";